import { useTheme } from '@material-ui/core/styles'

interface IStatus {
  [key: string]: {
    text: string,
    color: string
  }
}

const useComplexity = () : IStatus => {
  const theme = useTheme()

  return {
    LOW: { text: 'Baixa', color: theme.palette.info.light },
    HIGH: { text: 'Alta', color: theme.palette.warning.dark }
  }
}

export default useComplexity
